import { Fragment, useEffect, useState } from "react";
// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import { getCateListData } from "../../context/apiState.js";
import Link from "react-router-dom/Link.js";
import styles from "../footer-new/Footer.module.css"
import HttpBaseUrl from "./../../httpservice/common.http.js";

function Footer(props) {
    const [allCateData, setAllCateData] = useState();

    let lang = localStorage.getItem("language") ? localStorage.getItem("language") : 1;

    const getIdFromToken = (adToken) => {
        if (adToken) {
            let idFromToken = adToken.split(".")[1].split("@@")[0];
            // console.log(idFromToken);
            return idFromToken;
        }
    }

    async function callAllCategory() {
        let allCategoryData = await getCateListData();
        if (allCategoryData) {
            // console.log(allCategoryData);
            setAllCateData(allCategoryData);
        }
    }
    // function sortCateNames(id,name){
    //     return id.catName.localeCompare(name.catName);

    // }
    useEffect(() => {
       callAllCategory();
    }, [])
    // const IMG_PATH = './assets/images/'
    return (

        <section className={styles.footerMain}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 mt-4">
                        <h2 className={`${styles.postTitleSmall} ${styles.fontSize20} mb-3 `}>
                            {lang == 2 ? process.env.REACT_APP_HOME_ABOUT_HIN : process.env.REACT_APP_HOME_ABOUT_ENG}
                        </h2>
                        <p className={styles.gridPostPara + " mt-2 "}>
                            {lang == 2 ? process.env.REACT_APP_HOME_ABOUT_CON_HIN : process.env.REACT_APP_HOME_ABOUT_CON_ENG}
                        </p>
                        {/* <div className={styles.footerSocial + " mt-3 "}>
                            <a href="https://www.facebook.com/people/Thefactmagic/61557423414071/" target="_blank"><img loading="lazy" src={`${HttpBaseUrl.getAssetsPath()}/facebook.png`} fetchPriority = "high" width="18" height="18" alt="It Is The Facebook Image" /></a>
                            <a href="https://twitter.com/i/flow/login?redirect_after_login=%2FThefactmagic" target="_blank"><img loading="lazy" src={`${HttpBaseUrl.getAssetsPath()}/twitter.png`} fetchPriority = "high" width="18" height="18" alt="It Is The Twitter Image" /></a>
                            <a href="https://www.linkedin.com/in/the-fact-magic-6126162b9/" target="_blank"><img loading="lazy" src={`${HttpBaseUrl.getAssetsPath()}/linkedin.png`} fetchPriority = "high" width="18" height="18" alt="It Is The Linkedin Image" /></a>
                            <a href="https://www.instagram.com/thefactmagic/?hl=en" target="_blank"><img loading="lazy" src={`${HttpBaseUrl.getAssetsPath()}/instagram.png`} fetchPriority = "high" width="18" height="18" alt="It Is The Instagram Image" /></a>
                        </div> */}
                    </div>
                    <div className = "col-md-12 mt-4">
                        <h2 className={`${styles.postTitleSmall} ${styles.fontSize20} mb-3}`}>
                            {lang == 2 ? process.env.REACT_APP_CATEGORY_TITLE_HIN : process.env.REACT_APP_CATEGORY_TITLE_ENG}
                        </h2>
                        <ul className={styles.footerCategories}>
                            {
                                allCateData ?
                                    allCateData.footerCategoryAll.sort((id, name) => id.catName.localeCompare(name.catName)).map((footerAllCategoryData, footerAllCategoryIndex) => {
                                        return (
                                            <Fragment key={footerAllCategoryIndex}>
                                                <li>
                                                    {/* <a href={`/category/${allCateData ? footerAllCategoryData.catId : null}/${props.footerConfig.utm_source}/${allCateData ? allCateData.adSlots ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null}`} target='_blank'>{footerAllCategoryData.catName}</a> */}
                                                    <a href={`/category/${allCateData ?footerAllCategoryData.catId : null}/${props.footerConfig.utm_source}/${allCateData ? allCateData.adSlots ? allCateData.adSlots.feedAd ? getIdFromToken(allCateData.adSlots.feedAd) : 0 : null : null}`}target='_blank'> {footerAllCategoryData.catName}</a>
                                                </li>
                                            </Fragment>
                                        )
                                    })
                                    : null
                            }

                        </ul>
                    </div>
                    <div id="footer_div_3" className={" row mt-3 " + styles?.footerBottom}>
                        <div className="col-md-12">
                            <p className={styles.fontSize13 + " m-0 "}>© Copyright 2025 <strong><a href="https://www.momagic.com/" target="_blank" style={{color: "#fff"}}>MoMAGIC Technologies Pvt. Ltd.</a></strong> All right reserved.</p>
                        </div>
                        <div className="col-md-12">
                            <div className={styles.footerBottomLinks + " mt-2 "}>
                                <a href={`/aboutus`} target="_blank">About Us</a>

                                {/* <Link to={{ pathname: '/aboutus', state: { hfhghf: 'Mahi Mar Raha hai' } }}>About</Link> */}
                                <a href={`/contactus`} target="_blank">Contact Us</a>
                                <a href={`/privacy-policy`} target="_blank">Privacy Policy</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer;